import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { FormSchemaType } from "@/features/hmo-consultation/schema"
import { useFormContext } from "react-hook-form"
import { Video, Phone, MessageSquare } from "lucide-react"
import { useWidgetColor } from "@/hooks/useWidgetColor"
import clsx from "clsx"


export function ContactMedium() {
  const form = useFormContext<FormSchemaType>()
  const widgetColor = useWidgetColor()

  return (
    <FormField
      control={form.control}
      name="contactMedium"
      render={({ field }) => (
        <FormItem>
          <FormLabel required>How would you like to contact your Doctor?</FormLabel>
          <FormControl className="mt-3">
            <RadioGroup
              onValueChange={field.onChange}
              value={field.value as string}
              className="flex flex-row flex-wrap gap-6 lg:gap-12"
            >
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="chat" />
                </FormControl>
                <FormLabel className={clsx("font-normal flex items-center gap-2", field.value === "chat" && "font-medium")}>
                  Chat
                  <MessageSquare size={16} style={{ color: widgetColor }} />
                </FormLabel>
              </FormItem>
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="video" />
                </FormControl>
                <FormLabel className={clsx("font-normal flex items-center gap-2", field.value === "video" && "font-medium")}>
                  Video
                  <Video size={16} style={{ color: widgetColor }} />
                </FormLabel>
              </FormItem>
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="voice" />
                </FormControl>
                <FormLabel className={clsx("font-normal flex items-center gap-2", field.value === "voice" && "font-medium")}>
                  Voice
                  <Phone size={16} style={{ color: widgetColor }} />
                </FormLabel>
              </FormItem>
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}